<template>
    <div>
        <v-card-title :class="[{'pt-3': $vuetify.breakpoint.smAndDown},
                               {'pt-2': $vuetify.breakpoint.mdAndUp}, 'px-3']">
            {{landesverbandLocal.name}} {{sportJahr.replace('_', '/')}}
            <v-spacer></v-spacer>
            <v-btn v-if="$vuetify.breakpoint.mdAndUp"
                   @click="print()" icon class="mr-2">
                <v-icon>mdi-printer</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-subtitle class="px-3">alle Tabellen</v-card-subtitle>
        <div v-if="$store.state.local.bindsRealtimeList" class="text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else-if="saisonenWithRanking.length>0">
            <v-row class="py-0" no-gutters>
                <v-col v-for="(saison, i) in saisonenWithRanking" :key="i" class="py-0"
                       xl="6" lg="12" cols="12">
                    <div class="subtitle-1 px-3 pb-2 my-0 font-weight-medium">{{saison.local.title}}</div>
                    <tabelle :saison="saison" :hide-legend="true" :dense="true"
                        :class="[{'mb-8': $vuetify.breakpoint.smAndDown},
                                 {'mb-4': $vuetify.breakpoint.mdAndUp}]">
                    </tabelle>
                </v-col>
            </v-row>
            <tabelle-legend style="width: 90%;"></tabelle-legend>
        </div>
        <v-alert v-else class="ma-3 pl-8" color="" border="left" elevation="2"
                 colored-border icon="mdi-information-outline">
            Es wurden noch keine Tabellen für diese Saison angelegt!
        </v-alert>
    </div>
</template>

<script>
    import Tabelle from "./tabelle";
    import TabelleLegend from "./tabelleLegend";
    export default {
        components: {
            TabelleLegend,
            Tabelle
        },
        name: "tabellen",
        props: ['sportJahr', 'lvId', 'saisonen', 'lv'],
        computed: {
            saisonenWithRanking(){
                return this.saisonen && this.lv ?
                    this.saisonen.filter(saison => !this.lv.ligen[saison.ligaId].noRanking ) : [];
            },
            landesverbandLocal(){
                return this.lvId !== 'NationaleLigen' ? this.$store.state.local.landesverbaende
                        .find(lv => lv.nameShort.trim() === this.lvId) :
                    this.$store.state.local.nationaleLigen;
            },
            landesverbandRaw(){
                return this.$store.state.realtime.landesverbaende[this.landesverbandLocal.id];
            },
        },
        methods: {
            print(){
                this.$store.state.local.printContainer = {
                    header: this.landesverbandLocal.name + ' ' + this.sportJahr.replace('_', '/'),
                    content: this.saisonenWithRanking,
                };
                this.$router.push({name: 'PrintTabellen',
                    query: {lvId: this.lvId}});
            },
        },
    }
</script>

<style scoped>

</style>